import { API } from 'aws-amplify';
import Vue from 'vue';
import EventBus from '@/EventBus';

const ApiName = 'esite';
const PathRoot = process.env.VUE_APP_METRICS_API_PATH;

const downlink = () => {
  if (navigator && navigator.connection) {
    return navigator.connection.downlink;
  }
  return null;
};

const Metrics = {
  send(data) {
    return new Promise((resolve, reject) => {
      const path = `${PathRoot}`;

      // Get current downlink if available
      const netSpeed = downlink();
      const body = {
        ...data,
        ...(netSpeed && { netSpeed: `${netSpeed} Mbps` }),
      };
      const init = {
        body,
      };

      // POST metrics to API
      API.post(ApiName, path, init)
        .then((/* response */) => {
          resolve();
        })
        .catch((error) => {
          const title = 'Metrics error';
          const text = error.response ? error.response.data : error;
          EventBus.$emit('reader-dialog', { type: 'warning', title, text });
          reject(text);
        });
    });
  },
};


Vue.prototype.$metrics = Metrics;

export { Metrics as default };
